import { createFileRoute } from '@tanstack/react-router';

import { NavigationBar } from '@/features/agents';

export const Route = createFileRoute('/_auth/_org/agents/$agentId')({
  component: NavigationBar,
  notFoundComponent: () => {
    return <p>Agent not found!</p>;
  },
});
